/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useCallback, useEffect } from 'react';
import { Button } from '@/components/button';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { loginRequest } from '@/configs/azure.config';
import { loginWithAzure } from '@/redux/slices/auth.slice';
import { useAppDispatch } from '@/redux/hooks';

// images
import logoAJ from '@/assets/images/logo-aj.png';

export default function LoginPage() {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const dispatch = useAppDispatch();

  const handleLogin = async () => {
    // await instance.logout();
    await instance.loginRedirect(loginRequest);
  };

  const getToken = useCallback(async () => {
    try {
      const accounts = instance.getAllAccounts();
      if (accounts.length === 0) {
        throw new Error('No accounts found. Please log in.');
      }

      const res = await instance.acquireTokenSilent({
        scopes: loginRequest.scopes,
        account: accounts[0]
      });

      return res.accessToken;
    } catch (e) {
      console.log(e);
    }
  }, [instance]);

  useEffect(() => {
    const authenticateUser = async () => {
      if (isAuthenticated) {
        const token = await getToken();
        dispatch(loginWithAzure(token!));
      }
    };
    authenticateUser();
  }, [isAuthenticated, dispatch, getToken]);

  return (
    <div css={rootStyles}>
      <div css={loginContainerStyles}>
        <img src={logoAJ} />
        <Button
          onClick={handleLogin}
          css={loginBtnStyles}
          type='primary'
          shape='round'
        >
          Đăng nhập
        </Button>
      </div>
    </div>
  );
}

const rootStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
`;

const loginBtnStyles = css`
  width: 100%;
`;

const loginContainerStyles = css`
  max-width: 50rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  padding: 2rem;
`;
